import { create } from 'zustand';

// Importar tipo desde shared/types
import type { Ingreso } from '../types';

interface IngresosStore {
  ingresos: Ingreso[];
  isLoading: boolean;
  error: string | null;
  
  // Actions
  setIngresos: (ingresos: Ingreso[]) => void;
  addIngresoOptimistic: (ingreso: Omit<Ingreso, 'id' | 'createdAt' | 'updatedAt'>) => Ingreso;
  updateIngresoAfterFirebase: (tempId: string, realIngreso: Ingreso) => void;
  removeIngresoOptimistic: (id: string) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  clearError: () => void;
  clearAll: () => void;
}

export const useIngresosStore = create<IngresosStore>((set) => ({
  ingresos: [],
  isLoading: false,
  error: null,

  setIngresos: (ingresos) => {
    set({ ingresos });
  },

  addIngresoOptimistic: (ingresoData) => {
    const tempId = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    const newIngreso: Ingreso = {
      id: tempId,
      ...ingresoData,
      fecha: ingresoData.fecha || new Date(),
      createdAt: new Date(),
      updatedAt: new Date(),
    };

    set(state => ({
      ingresos: [newIngreso, ...state.ingresos]
    }));

    return newIngreso;
  },

  updateIngresoAfterFirebase: (tempId, realIngreso) => {
    set(state => ({
      ingresos: state.ingresos.map(ingreso => 
        ingreso.id === tempId ? realIngreso : ingreso
      )
    }));
  },

  removeIngresoOptimistic: (id) => {
    set(state => ({
      ingresos: state.ingresos.filter(ingreso => ingreso.id !== id)
    }));
  },

  setLoading: (loading) => set({ isLoading: loading }),
  
  setError: (error) => {
    set({ error });
  },
  
  clearError: () => set({ error: null }),
  
  clearAll: () => set({ ingresos: [], isLoading: false, error: null }),
}));

